import React, {Component} from 'react';
import moment from 'moment';
import {Row, Col, Form, Input, InputNumber, DatePicker, Button, Modal, Upload, Icon, Select} from 'antd';
import {api, app} from "../../app";
import head_default from "../../assets/head_default_img.png";
import 'moment/locale/zh-cn';

moment.locale('zh-cn');

const FormItem = Form.Item;
const {TextArea, Group} = Input;
const Option = Select.Option;

class trainadd extends Component {
    constructor(props) {
        super(props);
        this.state = {
            submit_loading: false,
            class_loading: true,
            previewVisible: false,
            classList: [],
            fileList: [],
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.handelClassList();
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handelClassList() {
        const _this = this;
        app.post(api.HomeClassList).then(({flag, data, msg}) => {
            if (_this._isMounted) {
                _this.setState({class_loading: false});
                if (flag === 1) {
                    _this.setState({classList: data});
                } else {
                    app.alert(msg, "warn");
                }
            }
        })
    }


    /**
     * 提交信息
     * @param e
     */
    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            console.log(values);
            if (!err) {
            }
        })
    }

    formItemLayout = (span) => {
        return {
            labelCol: {span: 6},
            wrapperCol: {span: span || 12, offset: 1}
        }
    }

    handleCancel = () => this.setState({previewVisible: false});

    handlePreview = (file) => {
        this.setState({
            previewImage: file.url || file.thumbUrl,
            previewVisible: true,
        });
    };

    handleChange = ({fileList}) => this.setState({fileList})

    render() {
        const {getFieldDecorator} = this.props.form,
            classList = this.state.classList || [],
            formItemLayout = this.formItemLayout(),
            submit_loading = this.state.submit_loading,
            {previewVisible, previewImage, fileList} = this.state;
        return (
            <div className="train-add">
                <div className="page-title">添加培训<span>Add the training</span></div>
                <Row className="page-content" type="flex" align="middle">
                    <Col span={11}>
                        <Form>
                            <FormItem
                                label="培训课程"
                                {...this.formItemLayout(4)}
                            >
                                {getFieldDecorator('class_id', {
                                    rules: [{required: true, message: '请选择培训技能!'}],
                                })(
                                    <Select placeholder="请选择培训技能" notFoundContent="无">
                                        {
                                            classList.map((cla, index) => {
                                                return (
                                                    <Option key={index + 1} value={cla.id}>{cla.names}</Option>
                                                )
                                            })
                                        }
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训时间"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('date', {
                                    rules: [{required: true, message: '请选择培训时间!'}],
                                })(
                                    <DatePicker.RangePicker
                                        showTime={{format: 'HH:mm'}}
                                        format="YYYY年MM月DD日 HH:mm"
                                        placeholder={['开始日期', '结束日期']}
                                        style={{width: '100%'}}
                                    />
                                )}
                            </FormItem>
                            <FormItem
                                label="培训地点"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('train_site', {
                                    rules: [{required: true, message: '请填写培训地点!'}],
                                })(
                                    <Input placeholder="请填写培训地点"/>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训师"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('train_teacher', {
                                    rules: [{required: true, message: '请填写培训师!'}],
                                })(
                                    <Input placeholder="请填写培训师"/>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训级别"
                                {...this.formItemLayout(4)}
                            >
                                {getFieldDecorator('goods_name0', {
                                    rules: [{required: true, message: '请选择培训级别!'}],
                                })(
                                    <Select placeholder="请选择培训级别">
                                        <Option value="jack">省</Option>
                                        <Option value="lucy">市</Option>
                                    </Select>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训人数限制"
                                {...this.formItemLayout(4)}
                            >
                                {getFieldDecorator('train_number', {
                                    rules: [{required: true, message: '请填写培训人数!'}],
                                })(
                                    <InputNumber style={{width: '100%'}} min={1} placeholder="请填写培训人数"/>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训内容"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('train_content', {
                                    rules: [{required: true, message: '请填写培训内容!'}],
                                })(
                                    <TextArea placeholder="请填写培训内容" autosize={{minRows: 1, maxRows: 4}}></TextArea>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训后获得技能"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('train_ppe')(
                                    <Select
                                        mode="tags"
                                        placeholder="请填写培训后可获得技能"
                                        allowClear={true}
                                        tokenSeparators={[',']}
                                        notFoundContent=""
                                    >

                                    </Select>
                                )}
                            </FormItem>
                            <FormItem
                                label="培训需要的装备"
                                {...formItemLayout}
                            >
                                {getFieldDecorator('train_equip')(
                                    <TextArea placeholder="请填写培训需要的装备" autosize={{minRows: 1, maxRows: 4}}></TextArea>
                                )}
                            </FormItem>
                            <FormItem
                                label="技术图片"
                                {...this.formItemLayout(17)}
                            >
                                {getFieldDecorator('train_img')(
                                    <Upload
                                        action="//jsonplaceholder.typicode.com/posts/"
                                        listType="picture-card"
                                        fileList={fileList}
                                        onPreview={this.handlePreview}
                                        onChange={this.handleChange}
                                    >
                                        {fileList.length >= 3 ? null :
                                            (<div>
                                                <Icon type="plus"/>
                                                <div className="ant-upload-text">上传</div>
                                            </div>)
                                        }
                                    </Upload>
                                )}
                            </FormItem>
                            <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                                <img alt="example" style={{width: '100%'}} src={previewImage}/>
                            </Modal>
                        </Form>
                    </Col>
                    <Col span={12} offset={1} className="type-sel">
                        <Row className="ts-select">
                            <Col span={7} style={{textAlign: 'right'}}>
                                <label title="职位选择" style={{height: 32, lineHeight: '32px'}}>职位选择</label>
                            </Col>
                            <Col span={10} offset={1}>
                                <Select placeholder="请选择培训技能" style={{width: '100%'}}>
                                    <Option value='1'>全队成员</Option>
                                    <Option value='2'>队长</Option>
                                    <Option value='3'>队员</Option>
                                    <Option value='4'>预备队员</Option>
                                    <Option value='5'>志愿者</Option>
                                </Select>
                            </Col>
                        </Row>
                        <div className="players">
                            {
                                [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16].map((player, index) => {
                                    return (
                                        <div key={index + 1} className="item">
                                            <img src={head_default} alt="" width="80" height="80"/>
                                            <p>(队员)</p>
                                            <p>(存心编号)</p>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div style={{textAlign: "center"}}>
                            <Button type="primary" loading={submit_loading}>创建培训</Button>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

export default Form.create()(trainadd);



// WEBPACK FOOTER //
// ./src/routes/task/Trainadd.jsx